module.exports = __webpack_public_path__ + "media/images/information-d8d8ba8671f041fb465aefebecf424f4.png";